import type { ReactNode } from 'react'
import { core } from '@musinsa/pbo-core'
// antd 로케일은 정적 데이터라 직접 import 금지(버전·테마 통제) 대상이 아니다 — 런타임 antd 는 pbo-core 와 같은 사본(재고수불 필터 선례).
//  pbo-core 가 ko 로케일을 export 하지 않아(DS 수정 대기 목록) 여기서 준다. 화면 폴더(핸드오프 동봉 검사 범위) 밖에 두어 화면은 core.* 만 쓴다.
import koKR from 'antd/es/locale/ko_KR'

/**
 * pbo-core 화면의 antd 문구를 한국어로 — 생성본 ConfigProvider 는 테마만 주고 locale 이 없어 날짜 칸 등이 영어("Select date")로 나온다.
 * antd 는 locale 을 주지 않은 안쪽 ConfigProvider 가 바깥 로케일을 물려받는다(LocaleProvider 를 새로 감싸지 않음) — 생성본·DS 를 고치지 않는다.
 */
export function PboKoLocale({ children }: Readonly<{ children: ReactNode }>) {
  return <core.ConfigProvider locale={koKR}>{children}</core.ConfigProvider>
}
